export default {"src":"/_next/static/media/quote-mark-end.c89b076c.svg","height":51,"width":67};